import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersNavigationItemsIndexResponseType } from "~/domains";

const request =
  async (): Promise<ApiMembersNavigationItemsIndexResponseType> => {
    const response =
      await new ApiClient().get<ApiMembersNavigationItemsIndexResponseType>(
        "/api/members/navigation_items",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisMembersNavigationItemsIndex = ({
  config,
}: PropsType = {}): UseQueryResult<ApiMembersNavigationItemsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisMembersNavigationItemsIndex"],
    queryFn: () => request(),
  });
};
